// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--1v1Ey","content":"index-module--content--2S7Rl"};